import Icon from '~/src/common/components/Icon';

import * as S from './layout';

interface Props {
  title: string;
  onReplace: () => void;
  onClick: () => void;
}

const SubstituteButton = ({ title, onClick, onReplace }: Props) => {
  return (
    <S.SubstituteButton
      onClick={() => {
        onClick();
        onReplace();
      }}>
      {title}
      <Icon name="chevron-right" size={16} />
    </S.SubstituteButton>
  );
};

export default SubstituteButton;
